module.exports = {
      id: "vikatan-play-usage",
      viewBox: "0 0 27.8 28.8",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#vikatan-play",
      toString: function () {
        return this.url;
      }
    }